import { render, staticRenderFns } from "./CompromisosHistorico.vue?vue&type=template&id=b104df96&scoped=true"
import script from "./CompromisosHistorico.vue?vue&type=script&lang=js"
export * from "./CompromisosHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b104df96",
  null
  
)

export default component.exports